<template>
<div class="chapter">
<div class="inner_page">
<p class="centerf">From <span class="txit">The Diary of Trevor</span></p>
<p class="noindent"><a id="ch02dairy"></a><a id="page_22">Sometimes I think my father never went to Vietnam. I don’t even know why I think that. I just do.</a></p><a id="page_22">
<p class="indent">Joe’s father went to Vietnam, and he tells stories. And you can tell, just by the stories, that he really did go.</p>
<p class="indent">I think my father maybe just says things sometimes that he thinks will make people proud of him or feel sorry for him.</p>
<p class="indent">My mom feels sorry for him because he went to Vietnam. She says no wonder he has problems. So I don’t tell her that I think maybe he never did.</p>
<p class="indent">Mr. St. Clair is so cool. I don’t care what Arnie says. I think he’s great, and I’m gonna do such a great job on that assignment, Mr. St. Clair won’t even be able to believe it.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch02dairy.vue?5b99f1a0